var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-edit--calendar-date-day-compose-edit-note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.775357142857143 6.3671428571428565c-0.8443468142857142 0 -1.6540882071428569 0.3354210857142857 -2.251125642142857 0.9324362357142856C1.9271972492857141 7.896626078571428 1.5917857142857141 8.706367471428571 1.5917857142857141 9.550714285714285v30.24392857142857c0 0.8442831428571428 0.335411535 1.6541837142857139 0.9324457864285713 2.2511033571428567 0.597037435 0.5969196428571428 1.4067788278571427 0.9324680714285714 2.251125642142857 0.9324680714285714h35.01928571428571c0.8442831428571428 0 1.6541837142857139 -0.3355484285714285 2.2511033571428567 -0.9324680714285714s0.9324680714285714 -1.4068202142857142 0.9324680714285714 -2.2511033571428567V9.550714285714285c0 -0.8443468142857142 -0.3355484285714285 -1.6540882071428569 -0.9324680714285714 -2.251135192857143C41.44882657142857 6.702563942857142 40.638926 6.3671428571428565 39.794642857142854 6.3671428571428565h-6.3671428571428565",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.142499999999998 1.5917857142857141v9.550714285714285",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33.427499999999995 1.5917857142857141v9.550714285714285",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.142499999999998 6.3671428571428565h15.917857142857141",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31.835714285714282 21.852161628571427 18.68253424285714 35.005278 12.734285714285713 35.81517857142857l0.8377886571428571 -5.948248528571428L26.697302657142856 16.713749999999997 31.835714285714282 21.852161628571427Z",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.96aa94fc70336c1b71e0ba343483e8b4.svg";
export { ForwardRef as ReactComponent };